import { setAutoFreeze } from 'immer';

setAutoFreeze(false);
